export function calendarDayWindow(day: string) {
  const from = new Date(`${day}T00:00:00`);
  const to = new Date(from); to.setDate(to.getDate() + 1);
  return Number.isFinite(from.getTime()) ? { start: from.toISOString(), end: to.toISOString() } : null;
}

export function localCalendarDate(date: Date): string {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString().slice(0, 10);
}

export function calendarWeekWindow(day: string) {
  const monday = new Date(`${day}T00:00:00`);
  if (!Number.isFinite(monday.getTime())) return null;
  monday.setDate(monday.getDate() - (monday.getDay() + 6) % 7);
  const days = Array.from({ length: 7 }, (_, index) => {
    const date = new Date(monday); date.setDate(date.getDate() + index); return localCalendarDate(date);
  });
  const end = new Date(monday); end.setDate(end.getDate() + 7);
  return { start: monday.toISOString(), end: end.toISOString(), days };
}

export interface CalendarBlock {
  id: string; subject: string; start: string; end: string; allDay: boolean;
  showAs: string; privateEvent: boolean; webUrl: string; draft?: boolean;
}
export interface CalendarPlacement {
  event: CalendarBlock; from: number; to: number; column: number; columns: number;
}
export function eventsOnDay(events: CalendarBlock[], day: string) {
  const window = calendarDayWindow(day)!;
  return events.filter(event => new Date(event.start).getTime() < new Date(window.end).getTime()
    && new Date(event.end).getTime() > new Date(window.start).getTime());
}
export function layoutCalendarDay(events: CalendarBlock[], day: string): CalendarPlacement[] {
  const window = calendarDayWindow(day)!;
  const minutes = (value: string) => { const date = new Date(value); return date.getHours() * 60 + date.getMinutes(); };
  const items = eventsOnDay(events, day).filter(event => !event.allDay).map(event => {
    const from = new Date(event.start).getTime() <= new Date(window.start).getTime() ? 0 : minutes(event.start);
    const end = new Date(event.end).getTime() >= new Date(window.end).getTime() ? 1440 : minutes(event.end);
    return { event, from, to: Math.min(1440, Math.max(from + 15, end)), column: 0, columns: 1 };
  }).sort((a, b) => a.from - b.from || b.to - a.to);
  let cluster: CalendarPlacement[] = []; let until = -1; let lanes: number[] = [];
  function finish() { for (const item of cluster) item.columns = lanes.length; }
  for (const item of items) {
    if (item.from >= until) { finish(); cluster = []; lanes = []; until = -1; }
    let column = lanes.findIndex(end => end <= item.from);
    if (column === -1) column = lanes.length;
    lanes[column] = item.to; item.column = column; cluster.push(item); until = Math.max(until, item.to);
  }
  finish(); return items;
}

export function localMeetingEnd(start: string, minutes: number): string {
  if (!start || !Number.isFinite(minutes) || minutes <= 0) return "";
  const from = new Date(start);
  if (!Number.isFinite(from.getTime())) return "";
  const canonicalStart = new Date(from.getTime() - from.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
  if (canonicalStart !== start) return "";
  const end = new Date(from.getTime() + minutes * 60_000);
  if (!Number.isFinite(end.getTime()) || end.getFullYear() > 9999) return "";
  const value = new Date(end.getTime() - end.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
  // A local input cannot identify the second occurrence in a repeated DST hour.
  return new Date(value).getTime() === end.getTime() ? value : "";
}
